export default __webpack_public_path__ + "static/media/Seascape_primary.7fbed8e7.jpg";